import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

// Import slices
import roommateSlice from './slices/roommateSlice'
import communitySlice from './slices/communitySlice'
import uiSlice from './slices/uiSlice'
import listingSlice from './slices/listingSlice'
import messageSlice from './slices/messageSlice'

export const store = configureStore({
  reducer: {
    roommate: roommateSlice,
    community: communitySlice,
    ui: uiSlice,
    listing: listingSlice,
    messages: messageSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector